(function($) {

    $(document).ready(function() {

        var $form = $('#js-filter-form'),
            $filter_button = $('#js-filter-button'),
            $age_cat = $form.find('#id_age_category'),
            $num_races = $form.find('#id_num_races'),
            $page = $('#id_page'),
            $paginator = $('.js-page-selector'),
            $name_sort = $form.find('#id_name_sort'),
            $sort_down = $form.find('.down'),
            $sort_up = $form.find('.up');

        $num_races.on('change', function(e) {
            if ($(this).val() !== '5') {
                document.getElementById('id_age_category').selectedIndex = 0;
                $age_cat.prop('disabled', true).css('opacity', 0.5);
            } else {
                $age_cat.prop('disabled', false).css('opacity', 1.0);
            }
        });

        $filter_button.on('click', function(e) {
            // when clicking the filter button, it implies new filter
            // conditions, in which case the page number needs resetting
            // to 1
            $page.val('1');
        });

        $sort_down.on('click', function (e) {
            $name_sort.val('desc');
            $form.submit();
        });
        $sort_up.on('click', function (e) {
            $name_sort.val('asc');
            $form.submit();
        });

        $paginator.on('click', function(e) {
            // set the page number into the hidden input and submit
            e.preventDefault();
            $page.val($(this).data('page-number'));
            $form.submit();
            return false;
        });
    });
})(window.jQuery);
